module.exports = __webpack_public_path__ + "img/main_wave.b82c3e60.png";